<template>

<div>
  <div class="form-group">
    <label for="locations">{{ $t('locations') }}</label>
    <Combobox
      multiple
      class="bg-white"
      name='locations'
      :placeholder="$t('select_a_item')"
      label="name"
      :options="locations"
      :initial-value="locationsToFilter"
      v-model="locationsToFilter"
    />
  </div>

  <div class="form-group mb-5">
    <button
      id="clear"
      class="btn btn-white btn-sm mr-2"
      type="button"
      @click="clear"
    >
      {{ $t('clear') }}
    </button>

    <button
      id="refresh"
      class="btn btn-primary btn-sm"
      type="button"
      @click="loadStockInventory"
    >
      {{ $t('refresh') }}
    </button>
  </div>

  <div class="row">
    <div class="col-lg-4" v-for="item in activeTypes" :key="item.activesTypeId">
      <div class="ibox light-bottom-shadow">
        <div class="ibox-title">
          <h5>{{ item.name }}</h5>
        </div>

        <div class="ibox-content">
          <div class="row">
            <div class="col-md-6">
              <h1 class="no-margins">{{ item.total }}</h1>
            </div>

            <div class="col-md-6 text-right">
              <b-button
                :disabled="item.total == 0"
                variant="primary"
                size='sm'
                pill
                @click="details(item.activesTypeId, item.name)"
              >
                {{ $t('details') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL LOCATION/STATUS -->
  <div
    ref='modalLocationStatus'
    id="modalLocationStatus"
    class="modal fade bd-example-modal-xl"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalLocationStatus"
    aria-hidden="true"
  >
    <div class="modal-xl modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title" id="modalTitle" />
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4" v-for="item in activeTypeDetails" :key="item.location">
              <div class="ibox">
                <div class="ibox-title">
                  <div class="d-flex justify-content-between">
                    <h5>{{ item.location }}</h5>
                    <h5>{{ item.total }}</h5>
                  </div>
                </div>

                <div class="ibox-content">
                  <ul class="list-group clear-list" v-for="(status, index) in item.allStatus" :key="status.name">
                    <li class="list-group-item" :class="{ 'fist-item': index == 0 }">
                      <span class="float-right">
                        <router-link
                          :to="{
                            name: 'listactives',
                            query: {
                              status: status.status,
                              location: item.location,
                              activeType: activeTypeSelected
                            }
                          }"
                          target="_blank"
                        >
                          <b-button
                            size="sm"
                            variant='primary'
                            class="btn-circle"
                          >
                            {{ status.total }}
                          </b-button>
                        </router-link>
                      </span>
                      {{ status.name }}
                    </li>
                  </ul>
                </div>

                <div class="ibox-title" v-if="activeTypeSelected == 6">
                  <div class="d-flex justify-content-between">
                    <h5>NÃO VINCULADOS</h5>
                    <h5>{{ item.notLinked }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row text-right">
            <div class="col-12">
              <b-button class="mt-3" id='closeModal' data-dismiss="modal">{{ $t('close') }}</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import { request } from '@/lib/http'
import locations from '@/config/locations'
import Combobox from '@/components/shared/ComboBox'

export default {
  name: 'ReportStockInventory',
  components: {
    LoaderButton,
    Combobox
  },

  data () {
    return {
      busy: false,
      activeTypes: [],
      activeTypeDetails: [],
      activeTypeSelected: undefined,
      locations,
      locationsToFilter: ['ESTOQUE']
    }
  },

  methods: {
    async details(id, name) {
      this.busy = true

      this.activeTypeSelected = id
      $('#modalTitle').text(name)
      $('#modalLocationStatus').modal('show')

      this.activeTypeDetails = await request({
        url   : 'stock-inventory-by-location-and-status',
        method: 'get',
        params: {
          activeType: id,
          locations: this.locationsToFilter
        }
      })

      this.busy = false
    },

    async loadStockInventory() {
      this.activeTypes = await request({
        url: 'stock-inventory',
        method: 'get',
        params: {
          locations: this.locationsToFilter
        }
      })
    },

    clear() {
      this.locationsToFilter = []
    }
  },

  async mounted() {
    await this.loadStockInventory()

    const global = this

    $('#modalLocationStatus').on('hide.bs.modal', function (event) {
      global.activeTypeDetails = []
    })
  }
}
</script>
